const copy = {
  legalDisclaimer: {
    body: (displayName: string) =>
      `This ${displayName} is powered by OpenAI and may generate information that is inaccurate or otherwise does not meet your needs or expectations. You should independently verify this generated information prior to using it, as Twilio is not responsible for your use of this generated information. Any generated information will in no way modify your agreement with Twilio covering your use of Twilio’s platform. For information regarding how this chatbot processes and protects your personal information, please review`,
    twilioPrivacyNotice: "Twilio's Privacy Notice",
  },
  liveChatDisclaimer:
    "Please do not include any personal data, including sensitive personal data or protected health information, in the Live Chat or attachments you upload to the Live Chat. Twilio analyzes the type, frequency, and patterns of requests we receive to help identify ways to improve our support services and anonymizes any personal data prior to conducting any analysis.",
  deprecatedPreChat: {
    headerText: "How can we help you? Ask our AI chat bot!",
    subText: "Need help getting started?",
    anchorText: "View quick start guide",
  },
  preChat: {
    headerText: "How can I help?",
    secondaryHeaderText: "Ask our AI Help Center assistant!",
    subText: "Need help getting started?",
    anchorText: "View quick start guide",
  },
  defaultPromptSuggestions: {
    accountHelp: {
      name: "Help with My Account",
      suggestions: {
        first: "How do I reset/change my Twilio password?",
        second: "How much does a phone number cost?",
        third: "When will my invoice be available and where can I find it? ",
      },
    },
    startingWithTwilio: {
      name: "Getting Started with Twilio",
      suggestions: {
        first:
          "What are A2P 10DLC campaign approval requirements for all brand types?",
        second: "How can I port my US phone number to Twilio?",
        third: "How can I get the delivery status of an SMS Message?",
      },
    },
  },
  submitTicketbutton: "Submit a ticket",
  submitFeedbackButton: "Submit feedback",
  errors: {
    liveChatTransfer: "Transfer to live chat failed. Please try again later.",
  },
};
export default copy;
